import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstanceJson from "../../../AxiosInstance/axiosInstanceJson";

export const createCountry = createAsyncThunk(
  "Country/createCountry",
  async (countryData, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.post(
        "/v1/admin/country/create-country",
        countryData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCountry = createAsyncThunk(
  "Country/getCountry",
  async (
    {
      id,
      status = "All",
      search = "",
      page = 1,
      limit = 10,
      startDate,
      endDate,
      paginate,
    },
    thunkAPI
  ) => {
    try {
      const { data } = await axiosInstanceJson.get(
        "/v1/admin/country/get-country",
        {
          params: {
            id,
            status,
            search,
            page,
            limit,
            startDate,
            endDate,
            paginate,
          },
        }
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Error occurred");
    }
  }
);

export const updateCountry = createAsyncThunk(
  "Country/updateCountry",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstanceJson.put(
        `/v1/admin/country/update-country/${id}`,
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCountry = createAsyncThunk(
  "Country/deleteCountry",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/country/delete-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const undoDeleteCountry = createAsyncThunk(
  "Country/undoDeleteCountry",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.put(
        `/v1/admin/country/undodelete-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getCountryById = createAsyncThunk(
  "Country/getById",
  async (id, thunkAPI) => {
    try {
      const { data } = await axiosInstanceJson.get(
        `/v1/admin/country/getSingle-country/${id}`
      );
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);
